import Label from "./Label";
import { Container as ContainerRoot } from './Container';
import { TriggerIcon } from './TriggerIcon';
import { Trigger } from './Trigger';
import Slot from './Slot';
import Field from './Field';
import Help from "./Help";

export { useSlots } from "../../context/ComponentesSlots";

export const Container = Object.assign(ContainerRoot, {
    Label: Label,
    Trigger: Trigger,
    Slot: Slot,
    Field: Field,
    Icon: TriggerIcon,
    Help: Help,
});